<template>
    <div>
        <label>
            Feature Name:
            <input
                type="text"
                ref="featureName"
                @change="changeName"
                :value="feature.name"
            />
        </label>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'PropTabGeneral',
        data() {
            return {};
        },
        props: {
            feature: {
                required: true
            }
        },
        computed: {
            ...mapGetters({
                featureNameIsUnique: 'form/featureNameIsUnique'
            })
        },
        methods: {
            async changeName(e) {
                // Ensure form field name uniqueness
                let newName = e.target.value;
                if (this.feature.name === newName) return;
                if (!this.featureNameIsUnique(newName)) {
                    await this.$store.dispatch('dialog/set', {
                        type: 'alert',
                        body: 'Feature name must be unique'
                    });
                    e.target.value = this.feature.name;
                    this.$refs.featureName.focus();
                    return;
                }
                this.$store.commit('form/updateFeature', {
                    feature, 
                    updates: { name: newName }
                })
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
